// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app';

// These imports load individual services into the firebase namespace.
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage';

import firebaseConfig from './firebaseConfig';

let config = firebaseConfig.firebaseConfig;

const firebaseApp = firebase.initializeApp(config);

export const auth = firebase.auth;
export const db = firebaseApp.database();
export const firestore = firebaseApp.firestore();
export const storage = firebaseApp.storage();
export const GoogleAuthProvider = new firebase.auth.GoogleAuthProvider();



// WEBPACK FOOTER //
// ./firebase.js